import {FC} from "react";
import CommonAppLayout from "./Common";
import {Users, BookmarkCheck, LayoutGrid, MessageCircle} from "lucide-react";
import useRecruiter from "contexts/User/useRecruiter";

const RecruiterAppLayout: FC = () => {
  const user = useRecruiter();

  const routes = [
    ...(user.isEnterprise
      ? [
          {
            name: "Employees",
            icon: LayoutGrid,
            path: "/employees",
          },
        ]
      : []),
    {
      name: "Talent Finder",
      icon: Users,
      path: "/talent",
    },
    {
      name: "BooksMatch Messages",
      icon: MessageCircle,
      path: "/chat",
    },
    {
      name: "Candidate Tracker",
      icon: BookmarkCheck,
      path: "/candidates",
    },
  ];

  return <CommonAppLayout routes={routes} />;
};

export default RecruiterAppLayout;
